export default __webpack_public_path__ + "static/media/readmekuleny.d012e4dc.png";